import ScoreByDayOfWeekWidget from './ScoreByDayOfWeekWidget';
export default ScoreByDayOfWeekWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/ScoreByDayOfWeekWidget/index.js